import {ChevronIcon, IconButton, Radio} from '@yandex-delivery/blocks'
import {memo} from 'react'

import {ExtraItemSlot, SlotDivider} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import {useRouteChange} from './hooks'
import {OptimizeRouteConfirmModal} from './OptimizeRouteConfirmModal/OptimizeRouteConfirmModal'
import {OptimizeRouteCustomModal} from './OptimizeRouteCustomModal/OptimizeRouteCustomModal'

export const RouteChange = memo(function RouteChange() {
  const {
    dragEndHandler,
    draftOptimizationState,
    destinationPoints,
    sourcePoint,
    openOptimizeRouteConfirmModalHandler,
    routeOrder,
    saveOptimizedRouteHandler,
    isOptimizeRouteConfirmModalOpened,
    isOptimizeRouteCustomModalHooksOpened,
    closeOptimizeRouteConfirmModalHandler,
    optimizationState,
    optimizeRouteHandler,
    resetNewOrderRouteHandler,
    saveNewOrderRouteHandler,
    openOptimizeRouteCustomModalHandler,
  } = useRouteChange()

  return (
    <>
      <ExtraItemSlot
        onClick={openOptimizeRouteCustomModalHandler}
        title={i18n('cargo.create.rout-change.reorder_addresses', 'Изменить порядок адресов')}
      >
        <IconButton onPress={openOptimizeRouteCustomModalHandler} size="xs" variant="ghost">
          <ChevronIcon />
        </IconButton>
      </ExtraItemSlot>
      {optimizationState === 'completed' ? (
        <ExtraItemSlot title={i18n('cargo.create.rout-change.route_optimized', 'Маршрут оптимизирован')} disabled>
          <Radio checked disabled />
        </ExtraItemSlot>
      ) : (
        <ExtraItemSlot
          description={i18n('cargo.create.rout-change.shipping_could_get_cheaper', 'Доставка может стать дешевле')}
          onClick={openOptimizeRouteConfirmModalHandler}
          title={i18n('cargo.create.rout-change.optimize_route', 'Оптимизировать маршрут')}
        >
          <ChevronIcon />
        </ExtraItemSlot>
      )}
      <OptimizeRouteConfirmModal
        isOpen={isOptimizeRouteConfirmModalOpened}
        onAccept={saveOptimizedRouteHandler}
        onDecline={closeOptimizeRouteConfirmModalHandler}
        optimizationState={optimizationState}
      />
      <OptimizeRouteCustomModal
        destinationPoints={destinationPoints}
        draftOptimizationState={draftOptimizationState}
        isOpen={isOptimizeRouteCustomModalHooksOpened}
        onAccept={saveNewOrderRouteHandler}
        onDecline={resetNewOrderRouteHandler}
        onDragEnd={dragEndHandler}
        onOptimize={optimizeRouteHandler}
        routeOrder={routeOrder}
        sourcePoint={sourcePoint}
      />
      <SlotDivider />
    </>
  )
})
